/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { ReadSelectedFileParams } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class FileSystemService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * select file
   *
   * LWM2M path: /1032//1
   *
   * @tapVersion(">=2.13")
   * @param fileName input
   * @return
   */
  selectFile(
    /*
     * name of the file to select. file name format = DOS  : 8.3    (namemax8.ext) ...
     */
    fileName: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.selectFileCall(fileName));
  }

  /**
   *
   *
   * LWM2M path: /1032//1
   *
   * @tapVersion(">=2.13")
   * @param fileName input
   * @return call options
   */
  selectFileCall(
    /*
     * name of the file to select. file name format = DOS  : 8.3    (namemax8.ext) ...
     */
    fileName: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.selectFile };

    callOptions.body = fileName;

    return callOptions;
  }

  /**
   * unselect file
   *
   * LWM2M path: /1032//2
   *
   * @tapVersion(">=2.13")
   * @return
   */
  unselectFile(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.unselectFileCall());
  }

  /**
   *
   *
   * LWM2M path: /1032//2
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  unselectFileCall(): ServiceCallType {
    const callOptions = { ...this.resources.unselectFile };

    return callOptions;
  }

  /**
   * write data to file
   *
   * LWM2M path: /1032//3
   *
   * @tapVersion(">=2.13")
   * @param data input
   * @return
   */
  writeSelectedFile(
    /*
     * data to write in the file. binary.
     */
    data: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.writeSelectedFileCall(data));
  }

  /**
   *
   *
   * LWM2M path: /1032//3
   *
   * @tapVersion(">=2.13")
   * @param data input
   * @return call options
   */
  writeSelectedFileCall(
    /*
     * data to write in the file. binary.
     */
    data: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.writeSelectedFile };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * write bundle id to file
   *
   * LWM2M path: /1032//10
   *
   * @tapVersion(">=2.13")
   * @param bundleId input
   * @return
   */
  setSelectedFileBundleId(
    /*
     * bundle id for the file being written. binary.
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.setSelectedFileBundleIdCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1032//10
   *
   * @tapVersion(">=2.13")
   * @param bundleId input
   * @return call options
   */
  setSelectedFileBundleIdCall(
    /*
     * bundle id for the file being written. binary.
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.setSelectedFileBundleId };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * write user id to file
   *
   * LWM2M path: /1032//11
   *
   * @tapVersion(">=2.13")
   * @param userId input
   * @return
   */
  setSelectedFileUserId(
    /*
     * user id for the file being written. binary.
     */
    userId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.setSelectedFileUserIdCall(userId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1032//11
   *
   * @tapVersion(">=2.13")
   * @param userId input
   * @return call options
   */
  setSelectedFileUserIdCall(
    /*
     * user id for the file being written. binary.
     */
    userId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.setSelectedFileUserId };

    callOptions.body = userId;

    return callOptions;
  }

  /**
   * read data from the selected file
   *
   * LWM2M path: /1032//4
   *
   * @tapVersion(">=2.13")
   * @param options input
   * @return
   */
  readSelectedFile(
    /*
     *
     */
    options: ReadSelectedFileParams,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.readSelectedFileCall(options));
  }

  /**
   *
   *
   * LWM2M path: /1032//4
   *
   * @tapVersion(">=2.13")
   * @param options input
   * @return call options
   */
  readSelectedFileCall(
    /*
     *
     */
    options: ReadSelectedFileParams,
  ): ServiceCallType {
    const callOptions = { ...this.resources.readSelectedFile };

    callOptions.body = options;

    return callOptions;
  }

  /**
   * delete file
   *
   * LWM2M path: /1032//6
   *
   * @tapVersion(">=2.13")
   * @return
   */
  deleteSelectedFile(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.deleteSelectedFileCall());
  }

  /**
   *
   *
   * LWM2M path: /1032//6
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  deleteSelectedFileCall(): ServiceCallType {
    const callOptions = { ...this.resources.deleteSelectedFile };

    return callOptions;
  }

  /**
   * clear all files
   *
   * LWM2M path: /1032//7
   *
   * @tapVersion(">=2.13")
   * @return
   */
  clearAllFiles(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.clearAllFilesCall());
  }

  /**
   *
   *
   * LWM2M path: /1032//7
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  clearAllFilesCall(): ServiceCallType {
    const callOptions = { ...this.resources.clearAllFiles };

    return callOptions;
  }

  /**
   * get size of the selected file
   *
   * LWM2M path: /1032//5
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getSelectedFileSize(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getSelectedFileSizeCall());
  }

  /**
   *
   *
   * LWM2M path: /1032//5
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getSelectedFileSizeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getSelectedFileSize };

    return callOptions;
  }

  /**
   * list files
   *
   * LWM2M path: /1032//9
   *
   * @tapVersion(">=2.13")
   * @return
   */
  listFiles(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.listFilesCall());
  }

  /**
   *
   *
   * LWM2M path: /1032//9
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  listFilesCall(): ServiceCallType {
    const callOptions = { ...this.resources.listFiles };

    return callOptions;
  }
}
